// extracted by mini-css-extract-plugin
module.exports = {"icon":"TTPDatePicker_icon__3NC1D"};